import react from "react";

import CalliopeKids1 from "../images/commercials/CalliopeKids/CALLIOPEKIDSFINAL_001 copy Large.jpeg";
import CalliopeKids2 from "../images/commercials/CalliopeKids/CALLIOPEKIDSFINAL_002 copy Large.jpeg";
import CalliopeKids3 from "../images/commercials/CalliopeKids/CALLIOPEKIDSFINAL_003 copy Large.jpeg";
import CalliopeKids4 from "../images/commercials/CalliopeKids/CALLIOPEKIDSFINAL_004 copy Large.jpeg";
import CalliopeKids5 from "../images/commercials/CalliopeKids/CALLIOPEKIDSFINAL_005 copy Large.jpeg";
import CalliopeKids6 from "../images/commercials/CalliopeKids/CALLIOPEKIDSFINAL_006 copy Large.jpeg";
import CalliopeKids7 from "../images/commercials/CalliopeKids/CALLIOPEKIDSFINAL_007 copy Large.jpeg";
import CalliopeKids8 from "../images/commercials/CalliopeKids/CALLIOPEKIDSFINAL_008 copy Large.jpeg";
import CalliopeKids9 from "../images/commercials/CalliopeKids/CALLIOPEKIDSFINAL_009 copy Large.jpeg";
import CalliopeKids10 from "../images/commercials/CalliopeKids/CALLIOPEKIDSFINAL_010 copy Large.jpeg";
import CalliopeKids11 from "../images/commercials/CalliopeKids/CALLIOPEKIDSFINAL_011 copy Large.jpeg";
import CalliopeKids12 from "../images/commercials/CalliopeKids/CALLIOPEKIDSFINAL_012 copy Large.jpeg";
import CalliopeKids13 from "../images/commercials/CalliopeKids/CALLIOPEKIDSFINAL_013 copy Large.jpeg";
import CalliopeKids14 from "../images/commercials/CalliopeKids/CALLIOPEKIDSFINAL_014 copy Large.jpeg";

const CalliopeKids = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={CalliopeKids1} alt="Calliope Kids Commercial Photography - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeKids2} alt="Calliope Kids Commercial Photography - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeKids3} alt="Calliope Kids Commercial Photography - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeKids4} alt="Calliope Kids Commercial Photography - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeKids6} alt="Calliope Kids Commercial Photography - Image 6"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeKids5} alt="Calliope Kids Commercial Photography - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeKids7} alt="Calliope Kids Commercial Photography - Image 7"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeKids8} alt="Calliope Kids Commercial Photography - Image 8"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeKids9} alt="Calliope Kids Commercial Photography - Image 9"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeKids10} alt="Calliope Kids Commercial Photography - Image 10"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeKids11} alt="Calliope Kids Commercial Photography - Image 11"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeKids12} alt="Calliope Kids Commercial Photography - Image 12"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeKids13} alt="Calliope Kids Commercial Photography - Image 13"/>
                </div>
                <div className="single portrait">
                    <img src={CalliopeKids14} alt="Calliope Kids Commercial Photography - Image 14"/>
                </div>
            </div>
        </div>
    );
}

export default CalliopeKids;